import type { AnnouncementService } from "../components/announcement";

import {
  createComment,
  deleteComment,
  deleteReaction,
  editComment,
  fetchActiveBoostedPost,
  fetchComments,
  fetchReactions,
  logBoostAction,
  upsertReaction,
} from "../api/announcement";

export function createAnnouncementService(): AnnouncementService {
  return {
    fetchReactions,
    upsertReaction,
    deleteReaction,
    fetchComments,
    createComment,
    editComment,
    deleteComment,
    fetchActiveBoostedPost,
    logBoostAction,
  };
}
